/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./HandlePostersSetting.vue?vue&type=template&id=869f1c18"
import script from "./HandlePostersSetting.vue?vue&type=script&lang=js"
export * from "./HandlePostersSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports